export default "__VITE_ASSET__B9kbUUAo__"